import { combinedApi as api } from "../combinedApi";
export const addTagTypes = ["Request"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getRequestGetRequestThatRequierAttention: build.query<
        GetRequestGetRequestThatRequierAttentionApiResponse,
        GetRequestGetRequestThatRequierAttentionApiArg
      >({
        query: (queryArg) => ({
          url: `/Request/GetRequestThatRequierAttention`,
          params: {
            from: queryArg["from"],
            to: queryArg.to,
            service: queryArg.service,
            user: queryArg.user,
            admin: queryArg.admin,
            failed: queryArg.failed,
            archived: queryArg.archived,
          },
        }),
        providesTags: ["Request"],
      }),
      putRequestResetById: build.mutation<
        PutRequestResetByIdApiResponse,
        PutRequestResetByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Request/Reset/${queryArg}`,
          method: "PUT",
        }),
        invalidatesTags: ["Request"],
      }),
      putRequestArchiveById: build.mutation<
        PutRequestArchiveByIdApiResponse,
        PutRequestArchiveByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Request/Archive/${queryArg}`,
          method: "PUT",
        }),
        invalidatesTags: ["Request"],
      }),
      putRequestDearchiveById: build.mutation<
        PutRequestDearchiveByIdApiResponse,
        PutRequestDearchiveByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/Request/Dearchive/${queryArg}`,
          method: "PUT",
        }),
        invalidatesTags: ["Request"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as requestApi };
export type GetRequestGetRequestThatRequierAttentionApiResponse =
  /** status 200 OK */ RunRequestDto[];
export type GetRequestGetRequestThatRequierAttentionApiArg = {
  from?: string;
  to?: string;
  service?: ServiceType;
  user?: boolean;
  admin?: boolean;
  failed?: boolean;
  archived?: boolean;
};
export type PutRequestResetByIdApiResponse = /** status 200 OK */ void;
export type PutRequestResetByIdApiArg = number;
export type PutRequestArchiveByIdApiResponse = /** status 200 OK */ void;
export type PutRequestArchiveByIdApiArg = number;
export type PutRequestDearchiveByIdApiResponse = /** status 200 OK */ void;
export type PutRequestDearchiveByIdApiArg = number;
export type ServiceType =
  | "jobPrepareOrFinishe"
  | "datacollector"
  | "irregulardatachecker"
  | "correlationcalculator"
  | "quantilecalculator"
  | "anomalycalculator"
  | "correlationresultcalculator"
  | "trendscalculator"
  | "correlationresultaggregator"
  | "anomalyscorecalculator"
  | "non";
export type CorrelationCalculationType =
  | "non"
  | "betweenMessstellen"
  | "betweenKenngroessen"
  | "all";
export type DataCollectorRequestType = "all" | "measurements" | "events";
export type RunRequestDto = {
  id?: number | null;
  service?: ServiceType;
  from?: string | null;
  to?: string | null;
  messstellen?: string[] | null;
  kenngroessen?: string[] | null;
  getLastX?: number | null;
  correlationType?: CorrelationCalculationType;
  analysisRequestId?: number | null;
  maxRunCount?: number | null;
  dataCollectorRequestType?: DataCollectorRequestType;
  irregularDataCheckerRules?: string[] | null;
  jobFinisherService?: ServiceType;
  status?: string | null;
  doNotStartBefore?: string | null;
  retries?: number | null;
  creationTime?: string | null;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export const {
  useGetRequestGetRequestThatRequierAttentionQuery,
  useLazyGetRequestGetRequestThatRequierAttentionQuery,
  usePutRequestResetByIdMutation,
  usePutRequestArchiveByIdMutation,
  usePutRequestDearchiveByIdMutation,
} = injectedRtkApi;
